import dayjs from '../../utils/dayjs';
import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Page, Popover, DatePicker, ButtonGroup, Button, SkeletonBodyText, BlockStack, SkeletonTabs, OptionList, Divider } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';

import helpers from 'helpers/index';
import { TypedJourney, useGetJourneys } from 'queries/journey.query';
import { Helmet } from 'react-helmet-async';
import __helpers from 'helpers/index';

import { EmptyState, Grid } from '@shopify/polaris';
import TripTimeColumn from './tripTimeColumn';
import TripManifest from './tripManifest';
import { UnassignedTicketsColumn } from './UnassignedTicketsColumn';
import { useGetTrip_manifest } from 'queries/trip_manifest.query';
import { TypedTripData } from 'queries/trip.query';
import AddTicketModal from './add_ticket.modal';
import { DragDropContext } from '@hello-pangea/dnd';
import { ENUM_TICKET_TYPE } from 'queries/ticket.query';
import { useMutateAdd_ticket_to_trip, useMutateRemove_ticket_from_trip, useMutateUpdate_ticket_position } from 'queries/ticket.query';

export default function TicketManager() {
  const rootSearchPath = window.location.search;
  let StringQuery: Record<string, any> = helpers.ExtractUrl(rootSearchPath);
  const initialQuery = useMemo(() => {
    return {
      d: StringQuery?.d || dayjs(new Date()).format('YYYY-MM-DD'),
      journey_id: StringQuery.journey_id || '', // default là 1 đi cho dễ
      h: StringQuery.h || '',
    };
  }, [StringQuery]);

  const [mainQuery, setMainQuery] = useState<any>(initialQuery);

  useEffect(() => {
    const buildURL = helpers.buildEndUrl(mainQuery);
    if (window.location.search !== buildURL) window.history.replaceState(null, 'ticket_managers', '/ticket_managers' + buildURL);
  }, [mainQuery]);

  /** KHỐI Chọn ngày */
  const [datepopoverActive, setDatepopoverActive] = useState(false);
  const toggleDatePopoverActive = useCallback(() => setDatepopoverActive((datepopoverActive) => !datepopoverActive), []);
  const [{ month, year }, setDate] = useState({ month: new Date().getMonth(), year: new Date().getFullYear() });
  const [selectedDates, setSelectedDates] = useState({
    start: new Date(initialQuery.d),
    end: new Date(initialQuery.d),
  });

  const selectedDateCallback = useCallback((d) => {
    setSelectedDates(d);
    setDatepopoverActive(false);
  }, []);

  /** gắn cờ load lần đầu tiên */
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    setMainQuery((oldValue) => {
      if (isFirstLoad) {
        return {
          ...oldValue,
          d: dayjs(selectedDates.start).format('YYYY-MM-DD'),
          h: oldValue.h || initialQuery.h,
        };
      } else {
        return {
          ...oldValue,
          d: dayjs(selectedDates.start).format('YYYY-MM-DD'),
          h: '',
        };
      }
    });
  }, [selectedDates]);

  const handleMonthChange = useCallback((month: number, year: number) => setDate({ month, year }), []);
  /** END KHỐI Chọn ngày */

  /** Khối lấy danh sách Journey */
  const [current_selected_journey_id, setCurrent_selected_journey_id] = useState('');
  const [currentJourneySelected, setCurrentJourneySelected] = useState<TypedJourney>();

  const {
    data: journeyFetchedData,
    isLoading: loadingJourney,
    isSuccess: loadingJourneySuccess,
  } = useGetJourneys({
    limit: 100,
    sort: 'createdAt:asc',
  });
  const [journeyData, setJourneyData] = useState<TypedJourney[]>(null);
  useEffect(() => {
    if (journeyFetchedData) {
      setJourneyData(journeyFetchedData.body);
    }
  }, [journeyFetchedData]);

  // --- BẠN THÊM ĐOẠN CODE NÀY VÀO ---
  useEffect(() => {
    // Nếu journeyData đã có dữ liệu và chưa có journey nào được chọn
    if (journeyData && journeyData.length > 0 && !currentJourneySelected) {
      // Tự động chọn journey đầu tiên trong danh sách
      let matchD: any = journeyData.find((el) => el.id.toString() === String(initialQuery.journey_id));
      setCurrentJourneySelected(matchD);
      if (matchD) setCurrent_selected_journey_id(matchD.id);
    }
  }, [journeyData, initialQuery]);

  /** Chỗ này fixed lỗi: nếu không có một journey nào thì chọn một cái mặc định hoặc cái đầu tiên */
  useEffect(() => {
    if (!initialQuery.journey_id && journeyData) {
      let findDefault = journeyData.find((al) => al.is_default === 1);
      let fistOne: any = findDefault || journeyData[0];
      setCurrentJourneySelected(fistOne);
      if (fistOne) setCurrent_selected_journey_id(fistOne.id);
    }
  }, [initialQuery.journey_id, journeyData]);
  // --- KẾT THÚC ĐOẠN CODE CẦN THÊM ---

  useEffect(() => {
    if (!current_selected_journey_id) return;

    setMainQuery((oldValue) => {
      // nếu là lần đầu thì giữ nguyên trip id từ URL
      if (isFirstLoad) {
        setIsFirstLoad(false);
        return {
          ...oldValue,
          journey_id: current_selected_journey_id,
          h: initialQuery.h,
        };
      }

      // còn về sau thì reset hết
      return {
        ...oldValue,
        journey_id: current_selected_journey_id,
        h: null,
      };
    });
  }, [current_selected_journey_id]);

  /** END Khối lấy danh sách Journey */

  const changeHourCallback = useCallback((hour: string) => {
    setMainQuery((old) => (old.h === hour ? old : { ...old, h: hour }));
  }, []);
  // const { data: tickets, isLoading: ticketLoading, refetch: refetchTickets } = useGetTickets(ticketQueryParams);
  const { mutateAsync: addTicketToTrip } = useMutateAdd_ticket_to_trip();
  const { mutateAsync: removeTicketFromTrip } = useMutateRemove_ticket_from_trip();
  const { mutateAsync: updateTicketPosition } = useMutateUpdate_ticket_position();

  /** giờ chạy được chọn sẽ phi vào đây */
  const [tripSelectedData, setTripSelectedData] = useState<TypedTripData>(null);
  const currentTripSelectedData = useCallback((data: TypedTripData) => {
    setTripSelectedData(data);
  }, []);

  const { data: manifestsData } = useGetTrip_manifest(tripSelectedData?.trip_manifest?.id);

  /** Thêm vé */
  const [showTicketModal, setShowTicketModal] = useState(false);
  const currentTripManifestID = useRef(null);
  const currentBookingPosition = useRef([]);
  const currentTicketType = useRef(ENUM_TICKET_TYPE.PASSENGER);
  const toggleTicketToTripManifest = useCallback(async (trip_manifest_id?: any, type?: any, position?: string[]) => {
    currentTripManifestID.current = trip_manifest_id;
    currentTicketType.current = type;
    currentBookingPosition.current = position;
    setShowTicketModal(true);
  }, []);

  // onBeforeCapture: props.onBeforeCapture,
  // onBeforeDragStart: props.onBeforeDragStart,
  // onDragStart: props.onDragStart,

  const onDragEnd = async (result) => {
    let { draggableId, source, destination } = result;
    // Nếu không có destination (thả ra ngoài) → bỏ qua
    if (!destination) return;
    draggableId = `` + helpers.parseNumeric(draggableId);

    /** kéo vé thả khỏi chuyến ... */
    if (destination.droppableId === 'unsigned_ticket') {
      if (source.droppableId === 'unsigned_ticket') {
        return console.log('Tự nó thả vào nó ...');
      }
      try {
        await removeTicketFromTrip(draggableId);
      } catch (e) {}

      return;
    }

    /** kéo vào chuyến */
    if (source.droppableId === 'unsigned_ticket') {
      if (destination.index > 0) {
        return console.log('Không kéo thả vào một item đang có...');
      }

      /** sắp xếp lại items thôi mà.... */
      if (destination.droppableId === 'unsigned_ticket') {
        return console.log('Tự nó thả vào nó ...');
      }
      let [func, position, manifest] = String(destination.droppableId).split(':'); // add_passenger_ticket:position_2:manifest_item_85
      try {
        await addTicketToTrip({
          trip_manifest_id: `` + __helpers.parseNumeric(manifest),
          ticket_id: draggableId,
          seat_position: String(position).replace('position_', ''),
        });
      } catch (e) {}
      return;
    }

    /** đổi vị trí của hai vé khác nhau */
    let [func, position, manifest] = String(destination.droppableId).split(':'); // add_passenger_ticket:position_2:manifest_item_85
    try {
      await updateTicketPosition({
        ticket_id: draggableId,
        seat_position: String(position).replace('position_', ''),
        trip_manifest_id: __helpers.parseNumeric(manifest),
      });
    } catch (e) {}
    // console.log(result, 'DRAG ÊR');
  };

  return (
    <>
      <Helmet>
        <title>Điều chuyến</title>
      </Helmet>

      {loadingJourney ? (
        <Page fullWidth>
          <BlockStack gap="400">
            <SkeletonTabs />
            <Grid columns={{ sm: 3 }}>
              <Grid.Cell columnSpan={{ xs: 6, sm: 2, md: 2, lg: 4, xl: 4 }}>
                <SkeletonBodyText />
              </Grid.Cell>
              <Grid.Cell columnSpan={{ xs: 6, sm: 4, md: 4, lg: 8, xl: 8 }}>
                <SkeletonBodyText />
              </Grid.Cell>
            </Grid>
          </BlockStack>
        </Page>
      ) : null}

      {loadingJourneySuccess ? (
        <Page fullWidth>
          <>
            <DragDropContext onDragEnd={onDragEnd}>
              <Grid>
                {/* Cột chọn tuyến/chuyến */}
                <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 4, xl: 3 }}>
                  <BlockStack gap="200">
                    <div style={{ fontSize: '1.3rem' }}>
                      <OptionList
                        title=""
                        onChange={(el) => setCurrent_selected_journey_id(el[0])}
                        options={journeyData?.map((al) => {
                          return {
                            value: `` + al.id,
                            label: al.journey_name,
                          };
                        })}
                        selected={[current_selected_journey_id]}
                      />
                    </div>
                    <Divider />
                    <ButtonGroup variant="segmented" fullWidth>
                      <Button
                        onClick={() => {
                          selectedDateCallback({ start: new Date(), end: new Date() });
                        }}
                        variant={selectedDates.start.toDateString() === new Date().toDateString() ? 'primary' : 'secondary'}
                      >
                        Hôm nay
                      </Button>
                      <Button
                        onClick={() => {
                          selectedDateCallback({
                            start: new Date(new Date().setDate(new Date().getDate() + 1)),
                            end: new Date(new Date().setDate(new Date().getDate() + 1)),
                          });
                        }}
                        variant={
                          selectedDates.start.toDateString() === new Date(new Date().setDate(new Date().getDate() + 1)).toDateString()
                            ? 'primary'
                            : 'secondary'
                        }
                      >
                        Ngày mai
                      </Button>
                      <Button
                        onClick={() => {
                          selectedDateCallback({
                            start: new Date(new Date().setDate(new Date().getDate() + 2)),
                            end: new Date(new Date().setDate(new Date().getDate() + 2)),
                          });
                        }}
                        variant={
                          selectedDates.start.toDateString() === new Date(new Date().setDate(new Date().getDate() + 2)).toDateString()
                            ? 'primary'
                            : 'secondary'
                        }
                      >
                        Ngày kia
                      </Button>
                    </ButtonGroup>
                    <div style={{ height: '30px' }}>
                      <Popover
                        active={datepopoverActive}
                        activator={
                          <div
                            style={{
                              fontSize: 'var(--p-font-size-500)',
                              color: 'var(--p-color-text)',
                              borderBottom: '1px dashed var(--p-color-border)',
                            }}
                          >
                            <Button variant="secondary" icon={CalendarIcon} fullWidth onClick={toggleDatePopoverActive}>
                              Chọn một ngày khác
                            </Button>
                          </div>
                        }
                        autofocusTarget="first-node"
                        onClose={toggleDatePopoverActive}
                      >
                        <Popover.Pane>
                          <Popover.Section>
                            <DatePicker
                              month={month}
                              year={year}
                              onChange={selectedDateCallback}
                              onMonthChange={handleMonthChange}
                              selected={selectedDates}
                            />
                          </Popover.Section>
                        </Popover.Pane>
                      </Popover>
                    </div>
                    <Divider />
                    {!mainQuery.journey_id ? (
                      <EmptyState heading="Chưa chọn chuyến" image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png">
                        <p>Chọn tuyến đường trước sau đó các giờ chạy sẽ có mặt tại đây.</p>
                      </EmptyState>
                    ) : (
                      <TripTimeColumn
                        currentJourneyID={mainQuery.journey_id}
                        currentSelectedDates={dayjs(selectedDates.start).format('YYYY-MM-DD')}
                        onHourChange={changeHourCallback}
                        currentTripSelectedDataCallback={currentTripSelectedData}
                      />
                    )}
                  </BlockStack>
                </Grid.Cell>

                {/* Cột danh sách chuyến theo giờ */}
                <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 8, xl: 6 }}>
                  {!mainQuery.h ? (
                    <EmptyState
                      image=""
                      heading=" "
                      footerContent='Chưa chọn giờ chạy để có thể hiển thị chuyến tại đây. Có thể bạn cần phải nhấn nút "vào lịch" trước'
                    />
                  ) : (
                    <TripManifest
                      time_id={mainQuery.h}
                      manifestsData={manifestsData}
                      tripData={tripSelectedData}
                      onNewTicket={toggleTicketToTripManifest}
                      onHourChange={changeHourCallback}
                    />
                  )}
                </Grid.Cell>

                {/* Cột vé chưa xếp chuyến */}
                <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 3 }}>
                  <UnassignedTicketsColumn selectedHour={tripSelectedData?.time || ''} manifest={manifestsData} />
                </Grid.Cell>
              </Grid>
            </DragDropContext>

            {/** Đoạn này coi chừng, đang load, fixed: phải gọi thế này vì nó cache mẹ nó thông tin cũ */}
            {showTicketModal ? (
              <AddTicketModal
                show={true}
                seat_position={currentBookingPosition.current}
                trip_manifest_id={currentTripManifestID.current}
                tripData={tripSelectedData}
                currentTicketType={currentTicketType.current}
                onClose={() => {
                  setShowTicketModal(false);
                }}
              />
            ) : null}
          </>
        </Page>
      ) : null}

      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
}

